// extracted by mini-css-extract-plugin
module.exports = {"iconText":"IconTextBox_iconText__gq_SF","text":"IconTextBox_text__h1bq3","icon":"IconTextBox_icon__B3nwb"};